import { NumberInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import NP from 'number-precision';
import React from 'react';

const getCurrency = (value) => {
  const numberValue = Number(value);
  if (isNaN(numberValue)) return ' - ';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numberValue);
};

const CalculoAproveitamentoCredito = ({ aproveitamentoCredito = {}, valorTotalCategorias = 0 }) => {
  const tipoAproveitamentoCredito = aproveitamentoCredito?.tipoAproveitamentoCredito;

  const aliquotaCbs = NP.divide(Number(aproveitamentoCredito.aliquotaCbs) || 0, 100);
  const aliquotaIbs = NP.divide(Number(aproveitamentoCredito.aliquotaIbs) || 0, 100);

  const valorBaseCbs = NP.times(valorTotalCategorias, aliquotaCbs);
  const valorBaseIbs = NP.times(valorTotalCategorias, aliquotaIbs);

  if (tipoAproveitamentoCredito === 'CREDITO_PARCIAL') {
    const percentual = NP.divide(Number(aproveitamentoCredito.percentualCredito) || 0, 100);

    const valorParcialCbs = NP.times(valorBaseCbs, percentual);
    const valorParcialIbs = NP.times(valorBaseIbs, percentual);

    return (
      <>
        <Grid item xs={12} sm={4}>
          <span>{`Valores base: IBS = ${getCurrency(valorBaseIbs)} | CBS = ${getCurrency(valorBaseCbs)}`}</span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            {`Valores parcial: IBS = ${getCurrency(valorParcialIbs)} | CBS = ${getCurrency(valorParcialCbs)}`}
          </span>
        </Grid>
      </>
    );
  }

  if (tipoAproveitamentoCredito === 'CREDITO_INTEGRAL') {
    const creditoTotal = NP.plus(valorBaseIbs, valorBaseCbs);
    return (
      <>
        <Grid item xs={12}>
          <span>
            <strong>{'Valores de crédito calculados: '}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito IBS'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito CBS'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito total'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(valorBaseIbs)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(valorBaseCbs)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(creditoTotal)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <span>{`Valores base: IBS = ${getCurrency(valorBaseIbs)} | CBS = ${getCurrency(valorBaseCbs)}`}</span>
        </Grid>
      </>
    );
  }
  return null;
};

const CamposAproveitamentoCredito = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  valorTotalCategorias,
  disabled,
}) => {
  const tipoAproveitamentoCredito = values?.aproveitamentoCredito?.tipoAproveitamentoCredito;
  const PARCIAL = tipoAproveitamentoCredito === 'CREDITO_PARCIAL';
  const inputSize = PARCIAL ? 2 : 4;

  return (
    <>
      {PARCIAL && (
        <Grid item xs={12} sm={4}>
          <NumberInput
            id="aproveitamentoCredito.percentualCredito"
            label="Percentual de crédito (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={values.aproveitamentoCredito?.percentualCredito}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={!!errors?.aproveitamentoCredito?.percentualCredito}
            error={errors?.aproveitamentoCredito?.percentualCredito}
            required
            disabled={disabled}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={inputSize}>
        <NumberInput
          id="aproveitamentoCredito.aliquotaIbs"
          label="Alíquota IBS (%)"
          decimalScale={8}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={(values) => {
            return !values.floatValue || values.floatValue <= 100;
          }}
          value={values?.aproveitamentoCredito?.aliquotaIbs}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={!!errors?.aproveitamentoCredito?.aliquotaIbs}
          error={errors?.aproveitamentoCredito?.aliquotaIbs}
          required
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={inputSize}>
        <NumberInput
          id="aproveitamentoCredito.aliquotaCbs"
          label="Alíquota CBS (%)"
          decimalScale={8}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={(values) => {
            return !values.floatValue || values.floatValue <= 100;
          }}
          value={values.aproveitamentoCredito?.aliquotaCbs}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={!!errors?.aproveitamentoCredito?.aliquotaCbs}
          error={errors?.aproveitamentoCredito?.aliquotaCbs}
          required
          disabled={disabled}
        />
      </Grid>
      <CalculoAproveitamentoCredito
        aproveitamentoCredito={values?.aproveitamentoCredito}
        valorTotalCategorias={valorTotalCategorias}
      />
      {PARCIAL && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            id="aproveitamentoCredito.observacaoJustificativa"
            name="aproveitamentoCredito.observacaoJustificativa"
            label="Observação (justificativa)"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values?.aproveitamentoCredito?.observacaoJustificativa}
            error={errors?.aproveitamentoCredito?.observacaoJustificativa}
            touched={touched?.aproveitamentoCredito?.observacaoJustificativa}
            fullWidth
            multiline
            maxLength={500}
            rows={3}
            variant="outlined"
            required
            disabled={disabled}
          />
        </Grid>
      )}
    </>
  );
};

const ContasPagarAproveitamentoCredito = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  aproveitamentoCreditoFlag,
  disabled,
}) => {
  const valorTotalCategorias = values?.categorias?.reduce((acc, categoria) => {
    const valorItem = Number(categoria?.valorBruto) || 0;
    return NP.plus(acc, valorItem);
  }, 0);

  const onChangeTipoAproveitamentoCredito = (event) => {
    handleChange(event);
    handleChange({ target: { id: 'aproveitamentoCredito.ativo', value: aproveitamentoCreditoFlag } });
    handleChange({ target: { id: 'aproveitamentoCredito.aliquotaIbs', value: '' } });
    handleChange({ target: { id: 'aproveitamentoCredito.aliquotaCbs', value: '' } });
    handleChange({ target: { id: 'aproveitamentoCredito.observacaoJustificativa', value: '' } });

    if (event.target.value === 'CREDITO_INTEGRAL') {
      handleChange({ target: { id: 'aproveitamentoCredito.percentualCredito', value: 100 } });
    } else {
      handleChange({ target: { id: 'aproveitamentoCredito.percentualCredito', value: '' } });
    }
  };

  return (
    <Grid container spacing={3} style={{ padding: 16 }}>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectInput
          id="aproveitamentoCredito.tipoAproveitamentoCredito"
          value={values?.aproveitamentoCredito?.tipoAproveitamentoCredito}
          onChange={(event) => {
            onChangeTipoAproveitamentoCredito(event);
          }}
          onBlur={handleBlur}
          label="Aproveitamento de crédito?"
          options={[
            { id: 'NAO_APROVEITA_CREDITO', title: 'Não aproveita crédito' },
            { id: 'CREDITO_INTEGRAL', title: 'Crédito integral' },
            { id: 'CREDITO_PARCIAL', title: 'Crédito parcial' },
          ]}
          touched={!!errors.aproveitamentoCredito?.tipoAproveitamentoCredito}
          error={errors.aproveitamentoCredito?.tipoAproveitamentoCredito}
          required
          disabled={disabled}
        />
      </Grid>
      {values?.aproveitamentoCredito?.tipoAproveitamentoCredito &&
        values?.aproveitamentoCredito?.tipoAproveitamentoCredito !== 'NAO_APROVEITA_CREDITO' && (
          <CamposAproveitamentoCredito
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            handleBlur={handleBlur}
            valorTotalCategorias={valorTotalCategorias}
            disabled={disabled}
          />
        )}
    </Grid>
  );
};

export default ContasPagarAproveitamentoCredito;
